import { NavigationGroup, NavigationPaths, NavigationRedirects, NavigationTab } from "../model/navigation/types";
import Services from "../pages/tabpages/Services";
import { AppIcons } from "./icons";
import MyExtensions from "../pages/tabpages/MyExtensions";
import AvailableExtensions from "../pages/tabpages/AvailableExtensions";
import AvailableServices from "../pages/tabpages/AvailableServices";
import ActiveUsers from "../pages/tabpages/ActiveUsers";
import InactiveUsers from "../pages/tabpages/InactiveUsers";
import ActiveServices from "../pages/tabpages/ActiveServices";
import SubmitSupportTicket from "../pages/tabpages/SubmitSupportTicket";
import ApiDocsPage from "../pages/tabpages/ApiDocsPage";

export const pageTabs: {[tab:string]: NavigationTab} = {
    services: {
        id: "services",
        title: "navigation.tab.myServices",
        component: Services
    },
    availableServices: {
        id: "availableServices",
        title: "navigation.tab.availableServices",
        component: AvailableServices
    },

    myExtensions: {
        id: "myExtensions",
        title: "navigation.tab.myExtensions",
        component: MyExtensions
    },
    availableExtensions: {
        id: "availableExtensions",
        title: "navigation.tab.availableExtensions",
        component: AvailableExtensions
    },

    submitTicket: {
        id: "submitTicket",
        title: "navigation.tab.submitTicket",
        component: SubmitSupportTicket
    },

    activeServices: {
        id: "activeServices",
        title: "navigation.tab.activeServices",
        component: ActiveServices
    },

    customers: {
        id: "customers",
        title: "navigation.tab.activeUsers",
        component: ActiveUsers
    },
    customerSettings: {
        id: "customerSettings",
        title: "navigation.tab.inactiveUsers",
        component: InactiveUsers
    },

    apiDocs: {
        id: "apiDocs",
        title: "navigation.tab.apiDocs",
        component: ApiDocsPage
    }
}

export const pagePaths: NavigationPaths = {
    
    // SERVICES
    services: { 
        id: "services",
        title: "navigation.page.services",
        url: "/services",
        Icon: AppIcons.Services,
        tabs: [ pageTabs.services.id, pageTabs.availableServices.id ]
    },

    // EXTENSIONS
    extensions: { 
        id: "extensions",
        title: "navigation.page.extensions",
        url: "/extensions",
        Icon: AppIcons.Extensions,
        tabs: [ pageTabs.myExtensions.id, pageTabs.availableExtensions.id ]
    },

    // SUPPORT
    support: { 
        id: "support",
        title: "navigation.page.support",
        url: "/support",
        Icon: AppIcons.Support,
        tabs: [ pageTabs.submitTicket.id ]
    },

    // ACTIVE SERVICES
    activeServices: { 
        id: "activeServices",
        title: "navigation.page.activeServices",
        url: "/active-services",
        Icon: AppIcons.List,
        elevated: true,
        tabs: [ pageTabs.activeServices.id ]
    },

    // USERS
    users: { 
        id: "users",
        title: "navigation.page.users",
        url: "/users-and-customers",
        Icon: AppIcons.Users,
        elevated: true,
        tabs: [ pageTabs.customers.id, pageTabs.customerSettings.id ]
    },

    // DOCS
    docs: { 
        id: "docs",
        title: "navigation.page.docs",
        url: "/docs",
        Icon: AppIcons.Api,
        elevated: true,
        tabs: [ pageTabs.apiDocs.id ]
    }

};

export const pageRedirects: NavigationRedirects = {
    home: {
        url: "/",
        to: pagePaths.services.url,
        exactUrl: true
    }
}

export const pageGroups: NavigationGroup[] = [
    {
        id: "Integrations",
        title: "navigation.group.integrations",
        children: [
            pagePaths.services.id,
            pagePaths.extensions.id,
            pagePaths.support.id
        ]
    },
    {
        id: "Administration",
        title: "navigation.group.administration",
        children: [
            pagePaths.activeServices.id,
            pagePaths.users.id,
            pagePaths.docs.id
        ]
    }
];